import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {BaseStatusTag, CheckmarkIcon} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'
import {landGreen} from '@modifi/colors'

const propTypes = {
  children: PropTypes.node,
}
const defaultProps = {
  children: null,
}

export type CompletedProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const Completed: React.FC<CompletedProps> = ({children, ...restProps}) => {
  const {t} = useTranslation('argus')

  return (
    <BaseStatusTag
      backgroundColor={landGreen}
      dataIdent="shipment-status-tag"
      data-status="completed"
      iconComponent={CheckmarkIcon}
      {...restProps}
    >
      {children || t('shipment-status.completed')}
    </BaseStatusTag>
  )
}

Completed.propTypes = propTypes
Completed.defaultProps = defaultProps

export default Completed
